import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useApp } from "../context/AppContext";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "CARZA respects your privacy. This policy explains what information we collect through this website and how it is used.",
      "Information we collect: When you book a service, request a proposal, apply to become a partner or request an investor deck, we collect the details you provide — such as your name, phone number, email address, company details and service location. We use this information only to respond to your request, deliver services and communicate service-related updates.",
      "How we use it: Submitted information is used to process bookings and enquiries, contact you about your request, and improve our services. We do not sell your personal information to third parties.",
      "Data storage: Information is stored securely in our systems and retained only as long as needed for the purposes above or as required by law.",
      "Contact: For any privacy question or deletion request, write to our team using the contact details in the footer of this website.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "Welcome to CARZA. By using this website or booking a service, you agree to the terms below.",
      "Services: CARZA provides technology-enabled, doorstep vehicle-care services delivered by trained service partners following CARZA's standardized processes. Service availability, pricing and slots may vary by city and are confirmed at the time of booking.",
      "Estimates: Prices shown during booking are estimates based on the selected service and vehicle type. The final amount is confirmed before service begins.",
      "Water-efficiency: CARZA's process is designed to reduce water usage compared to conventional washes. Published water-usage claims will reflect verified testing only.",
      "Liability: CARZA's liability for any service is limited to the value of the service performed. Vehicles are inspected with the partner at the time of service.",
      "Contact: For questions about these terms, reach us using the contact details in the footer of this website.",
    ],
  },
};

export default function LegalPage({ kind }) {
  const { config } = useApp();
  const c = CONTENT[kind] || CONTENT.privacy;
  return (
    <>
      <Navbar />
      <main className="pt-[68px] pb-20">
      <div className="container-x max-w-3xl py-16" data-testid="legal-page">
        <span className="eyebrow">CARZA · Legal</span>
        <h1 className="mt-5 font-display text-4xl font-bold tracking-tight text-paper sm:text-5xl">{c.title}</h1>
        <div className="mt-8 flex flex-col gap-5">
          {c.body.map((p, i) => (
            <p key={i} className="text-[15px] leading-relaxed text-mist">{p}</p>
          ))}
        </div>
        <p className="mt-10 border-t border-white/5 pt-6 font-mono text-[11px] text-mist-2">Last updated: January 2026 · {config.brand.email}</p>
      </div>
      </main>
      <Footer />
    </>
  );
}
